'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtDepthCategoryRealEstate(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtDepthCategoryRealEstate');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.26 3.88498H12.18V10.455H2.05501V3.88498H3.96001V5.60998H10.26V3.88498ZM3.96001 7.27498V8.80499H10.26V7.27498H3.96001ZM0.51001 12.06H13.71V13.8H8.07001V17.535H6.15001V13.8H0.51001V12.06Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7936 8.60999V9.68999H27.4336V11.31H14.2336V9.68999H19.8736V8.60999H15.9136V3.62999H25.6186V5.20498H17.8336V7.01999H25.7686V8.60999H21.7936ZM22.4986 12.33C23.2286 12.33 23.8586 12.445 24.3886 12.675C24.9286 12.895 25.3386 13.2 25.6186 13.59C25.9086 13.98 26.0536 14.425 26.0536 14.925C26.0536 15.425 25.9136 15.87 25.6336 16.26C25.3536 16.66 24.9436 16.97 24.4036 17.19C23.8636 17.41 23.2286 17.52 22.4986 17.52H19.1686C18.4386 17.52 17.8036 17.41 17.2636 17.19C16.7336 16.97 16.3286 16.66 16.0486 16.26C15.7686 15.87 15.6286 15.425 15.6286 14.925C15.6286 14.425 15.7686 13.98 16.0486 13.59C16.3286 13.2 16.7336 12.895 17.2636 12.675C17.8036 12.445 18.4386 12.33 19.1686 12.33H22.4986ZM22.1536 15.87C22.8236 15.87 23.3186 15.785 23.6386 15.615C23.9686 15.445 24.1336 15.21 24.1336 14.91C24.1336 14.29 23.4736 13.98 22.1536 13.98H19.5286C18.1986 13.98 17.5336 14.29 17.5336 14.91C17.5336 15.21 17.6936 15.445 18.0136 15.615C18.3436 15.785 18.8486 15.87 19.5286 15.87H22.1536Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3123 3.35999V6.67499H41.3373V8.41499H39.3123V13.725H37.3923V3.35999H39.3123ZM31.7973 8.92498C31.1173 9.97499 30.1023 10.95 28.7523 11.85L27.6573 10.38C28.8573 9.57999 29.7223 8.73999 30.2523 7.85999C30.7923 6.96999 31.0623 5.99999 31.0623 4.94999V3.85499H32.9373V4.94999C32.9373 5.74999 32.8223 6.51998 32.5923 7.25998L36.2823 10.14L35.1873 11.565L31.7973 8.92498ZM30.1023 12.84H32.0073V15.63H39.9723V17.37H30.1023V12.84Z",
    fill: fill || '#1E1E23'
  }));
}
var IcTxtDepthCategoryRealEstate$1 = /*#__PURE__*/memo(IcTxtDepthCategoryRealEstate);

export { IcTxtDepthCategoryRealEstate$1 as default };
